/**
 * Holiday date calculations — zero maintenance, works for any year.
 */

/** Påskedag via Butcher's algoritme (Anonymous Gregorian) */
export function getEasterDate(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
}

/** Black Friday: 4. fredag i november */
export function getBlackFriday(year) {
    const nov1 = new Date(year, 10, 1);
    const dayOfWeek = nov1.getDay();
    const firstFriday = dayOfWeek <= 5 ? 1 + (5 - dayOfWeek) : 1 + (12 - dayOfWeek);
    return new Date(year, 10, firstFriday + 21);
}

const holidayResolvers = {
    easter: getEasterDate,
    blackfriday: getBlackFriday,
};

/** Resolve a date spec to a concrete Date */
export function resolveDate(spec, year) {
    if (spec.holiday) {
        const resolver = holidayResolvers[spec.holiday];
        if (!resolver) throw new Error(`Unknown holiday: ${spec.holiday}`);
        const base = resolver(year);
        const result = new Date(base);
        result.setDate(result.getDate() + (spec.offset || 0));
        return result;
    }
    return new Date(year, spec.month - 1, spec.day);
}

/** Check if date falls within a theme range (handles year-crossing like NYE) */
export function isDateInRange(date, fromSpec, toSpec) {
    const year = date.getFullYear();
    const start = resolveDate(fromSpec, year);
    const end = resolveDate(toSpec, year);

    if (end >= start) {
        return date >= start && date <= end;
    }

    // Year-crossing range (e.g. Dec 28 → Jan 2)
    const startPrev = resolveDate(fromSpec, year - 1);
    const endThis = resolveDate(toSpec, year);
    const startThis = resolveDate(fromSpec, year);
    const endNext = resolveDate(toSpec, year + 1);

    return (date >= startThis) || (date <= endThis && date >= startPrev);
}
